"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _supplier = require("@/api/supplier");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SupplierPurchase',
  data: function data() {
    return {
      loading: false,
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadList();
  },
  methods: {
    purchase: function purchase(row) {
      return row && (row.purchaseOrder || row.order) || {};
    },
    loadList: function loadList() {
      var _this = this;
      this.loading = true;
      (0, _supplier.supplierPurchaseListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    runAction: function runAction(row, action) {
      var _this2 = this;
      var id = this.purchase(row).id;
      (0, _supplier.supplierPurchaseActionApi)(id, {
        action: action,
        version: this.purchase(row).version
      }).then(function () {
        _this2.$message.success('操作成功');
        _this2.loadList();
      });
    }
  }
};